import { formatDistanceToNow, format, differenceInHours } from 'date-fns';
import { ensureUtc } from './formatters';

/**
 * Format the last refresh timestamp based on how recent it is.
 * - If less than 24 hours ago: show relative time (e.g., "11 hours ago")
 * - Otherwise: show formatted date/time (e.g., "04/15/2026 - 03:30 PM")
 *
 * @param timestamp ISO timestamp string or null
 * @returns Formatted string or "Never" if null
 */
export function formatLastRefresh(timestamp: string | null): string {
  if (!timestamp) {
    return "Never";
  }

  try {
    const date = new Date(ensureUtc(timestamp));
    const now = new Date();
    const hoursDiff = differenceInHours(now, date);

    if (hoursDiff < 24) {
      return formatDistanceToNow(date, { addSuffix: true });
    } else {
      return format(date, 'MM/dd/yyyy - hh:mm a');
    }
  } catch (error) {
    console.error('Error formatting last refresh timestamp:', error);
    return "Unknown";
  }
}
